import api from 'api'

export const createField = async (stepId, payload) => {
  const { data } = await api.post(`/step/${stepId}/field`, payload)

  return data
}
